import { FrontendToolHandler } from '../types'
import { getActiveAgentBus, isAgentBusBound } from '../fdc3Bridge'

/**
 * `linkToChannel` (Spec 010 §7) — link Ali to an FDC3 colour channel, or unlink it.
 * Folds `joinUserChannel(id)` + `leaveCurrentChannel()` into one verb to save the
 * `body.tools` budget: pass a channel id to join, or `"none"` to leave. Changing
 * what Ali is linked to is consequential, so it requires confirmation.
 *
 * Only offered when Ali is bound to a Desktop Agent; a no-op off the bus.
 */
export const linkToChannel: FrontendToolHandler = {
  enabled: isAgentBusBound,
  definition: {
    name: 'linkToChannel',
    description:
      'Link Ali to a colour channel so it shares context with apps on it; pass "none" to unlink.',
    parameters: {
      type: 'object',
      properties: {
        channel: {
          type: 'string',
          description: 'A channel id from state.workspaceContext, or "none" to unlink.'
        }
      },
      required: ['channel']
    },
    requiresConfirmation: true
  },
  execute: async (args) => {
    const bus = getActiveAgentBus()
    if (!bus || !bus.isBound()) {
      return { success: false, message: 'Ali is not connected to a workspace bus.' }
    }
    const channel = typeof args.channel === 'string' ? args.channel.trim() : ''
    if (!channel) {
      return { success: false, message: 'A channel id (or "none") is required.' }
    }
    const result = await bus.linkToChannel(channel)
    return { success: result.ok, message: result.message, data: result.data }
  }
}
